<template>
  <v-row class="ma-0 pa-0 pb-2">
    <v-col class="pl-0" cols="12" sm="12" md="8" lg="8" xl="8">
      <v-card class="py-4 px-6">
        <CompletedRevs
          :revs="lastCompletedRevs"
          :organizationId="organizationId"
          :isLoading="isLoading"
          :isSelfProfile="isSelfProfile"
        />
      </v-card>
    </v-col>
    <v-col class="pr-0" cols="12" sm="12" md="4" lg="4" xl="4">
      <v-card class="py-4 px-6">
        <Achievements :isLoading="isLoading" :stats="stats" />
      </v-card>
      <v-card class="mt-4">
        <Collaborators
          :collaborators="currentCollaborators"
          :organizationId="organizationId"
          :isLoading="isLoading"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CompletedRevs from './CompletedRevs.vue'
import Achievements from './Achievements.vue'
import Collaborators from './Collaborators.vue'

export default {
  name: 'HighlightsTab',
  props: {
    organizationId: {
      required: true,
      type: String,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
    activity: {
      required: true,
      type: Object,
    },
    isSelfProfile: {
      required: true,
      type: Boolean,
    },
    stats: {
      required: true,
      type: Object,
    },
  },
  components: {
    CompletedRevs,
    Achievements,
    Collaborators,
  },
  computed: {
    currentCollaborators() {
      return this.activity?.currentCollaborators ?? []
    },

    lastCompletedRevs() {
      return this.activity?.lastCompletedRevs ?? []
    },
  },
}
</script>
